import React, { useState, useEffect, useRef } from 'react';
import { Github, ArrowRight } from 'lucide-react';
import './ProjectCard.css';

const ImageSlider = ({ images }) => {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, [images.length]);

  return (
    <div className="proj-slider">
      <div className="proj-slider-track">
        {images.map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`screenshot ${i + 1}`}
            className={`proj-slider-img${i === current ? ' active' : ''}`}
          />
        ))}
      </div>
      <div className="proj-slider-dots">
        {images.map((_, i) => (
          <button
            key={i}
            className={`proj-slider-dot${i === current ? ' active' : ''}`}
            onClick={() => {
              clearInterval(intervalRef.current);
              setCurrent(i);
              intervalRef.current = setInterval(
                () => setCurrent((p) => (p + 1) % images.length),
                1000
              );
            }}
            aria-label={`Go to screenshot ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

const ProjectCard = ({ project, isVisible, animationDelay }) => {
  const IconComponent = project.icon;

  return (
    <div
      className={`project-card glass glass-hover card-3d ${
        isVisible ? 'animate-scale-in' : 'opacity-0'
      }`}
      style={{ animationDelay: `${animationDelay}s` }}
    >
      <div className="project-card-content">
        <div className="project-icon-container">
          <div className="project-icon-wrapper">
            <IconComponent className="project-icon" />
          </div>
        </div>

        <div className="project-details">
          <div className="project-header">
            <h3 className="project-title">{project.title}</h3>
            {project.featured && (
              <span className="project-featured-badge">Featured</span>
            )}
          </div>
          <p className="project-period">{project.period}</p>
          <p className="project-description">{project.description}</p>

          {project.images && project.images.length > 0 && (
            <ImageSlider images={project.images} />
          )}

          <ul className="project-highlights">
            {project.highlights.map((highlight, i) => (
              <li key={i} className="project-highlight-item">
                <span className="highlight-bullet">▹</span>
                <span>{highlight}</span>
              </li>
            ))}
          </ul>

          <div className="project-tech-list">
            {project.tech.map((tech, i) => (
              <span key={i} className="tech-badge">
                {tech}
              </span>
            ))}
          </div>

          <div className="project-actions">
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              className="project-github-btn"
            >
              <Github size={16} />
              GitHub
              <ArrowRight size={14} className="arrow-icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
